"use client";

import { c as _c } from "react/compiler-runtime";
import type { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import { distributionPlanApiPost } from "@/services/distribution-plan-api";
import { useState } from "react";
import DistributionPlanPrimaryBtn from "../common/DistributionPlanPrimaryBtn";
export default function CreateDistributionPlan(t0) {
  const $ = _c(23);
  const {
    onSuccess
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "",
      description: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [formValues, setFormValues] = useState(t1);
  const [isLoading, setIsLoading] = useState(false);
  let t2;
  if ($[1] !== formValues) {
    t2 = event => {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.value
      });
    };
    $[1] = formValues;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleChange = t2;
  let t3;
  if ($[3] !== formValues.description || $[4] !== formValues.name || $[5] !== onSuccess) {
    const createPlan = async () => {
      if (!formValues.name || !formValues.description) {
        return;
      }
      setIsLoading(true);
      const {
        success,
        data
      } = await distributionPlanApiPost({
        endpoint: "/allowlists",
        body: {
          name: formValues.name,
          description: formValues.description
        }
      });
      if (success && data?.id) {
        onSuccess(data.id);
      } else {
        setIsLoading(false);
      }
    };
    t3 = async event_0 => {
      event_0.preventDefault();
      await createPlan();
    };
    $[3] = formValues.description;
    $[4] = formValues.name;
    $[5] = onSuccess;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSubmit = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="tw-max-w-sm tw-text-lg tw-text-white tw-font-medium tw-mb-0">Create new Distribution plan</p>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-100">Name</label>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== formValues.name || $[10] !== handleChange) {
    t6 = <div>{t5}<div className="tw-mt-2"><input type="text" name="name" value={formValues.name} onChange={handleChange} required={true} autoComplete="off" placeholder="Make a name for your distribution" className="tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-700/40 tw-text-white tw-font-light tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700/40 hover:tw-ring-iron-700 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div></div>;
    $[9] = formValues.name;
    $[10] = handleChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-100">Description</label>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== formValues.description || $[14] !== handleChange) {
    t8 = <div className="tw-mt-6">{t7}<div className="tw-mt-2"><input type="text" name="description" value={formValues.description} onChange={handleChange} required={true} autoComplete="off" placeholder="Description of your drop" className="tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-700/40 tw-text-white tw-font-light tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700/40 hover:tw-ring-iron-700  placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div></div>;
    $[13] = formValues.description;
    $[14] = handleChange;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== isLoading) {
    t9 = <div className="tw-mt-8 tw-flex tw-justify-end"><DistributionPlanPrimaryBtn loading={isLoading} type="submit" onClick={_temp} isDisabled={isLoading}>Create</DistributionPlanPrimaryBtn></div>;
    $[16] = isLoading;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleSubmit || $[19] !== t6 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div className="tw-p-6">{t4}<form className="tw-mt-6" onSubmit={handleSubmit}>{t6}{t8}{t9}</form></div>;
    $[18] = handleSubmit;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp() {}